import { TPropertyCardPropertyData } from '@/card/card-types';
import { PropertyDotAndType } from '@/map/property-dot-and-type';
import { RsuiteTooltipWrapper } from '@/widgets/components/tooltips';
import {
  AddressWrapper,
  PropertyCardBodyWrapper,
  SummaryWrapper,
  TextValue,
  VerifiedPropertyIcon,
  Violations,
} from '../property-card-styles';

interface Props {
  detailItems: TPropertyCardPropertyData;
  displayedAddress: string;
  printMode: boolean;
}

export function PresentationalPropertyCardBody(props: Props) {
  const { detailItems, displayedAddress, printMode } = props;

  const hasViolations =
    Array.isArray(detailItems.violations) && detailItems.violations.length > 0;

  return (
    <PropertyCardBodyWrapper data-cy="property-card-body" printMode={printMode}>
      <AddressWrapper>
        <div>{displayedAddress}</div>

        <VerifiedPropertyIcon
          verifiedStatus={detailItems.verifiedStatus}
          tooltipPosition="bottom"
        />
      </AddressWrapper>

      <SummaryWrapper>
        <TextValue>
          <PropertyDotAndType property={detailItems} />
        </TextValue>
      </SummaryWrapper>

      <Violations>
        {hasViolations && (
          <RsuiteTooltipWrapper
            text={detailItems.violations?.join('\r\n')}
            tooltipIdentifier="property-card-violations"
            tooltipPosition="right"
          >
            <span
              aria-describedby="property-card-violations"
              aria-label="Violations for property"
            >
              Possible Violations ({detailItems.violations.length})
            </span>
          </RsuiteTooltipWrapper>
        )}
      </Violations>
    </PropertyCardBodyWrapper>
  );
}
